import { Box, ToastAnimateFrom, ToastContent, ToastPosition } from '@bechtel/gds';
import { FC } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from '~/components';
import { HeaderLogo } from '~/components/header-logo';
import { PageHeader } from '~/components/page-header';
import ActiveRequisition from './active-requisition';
import { RequisitionHistory } from './history';

const Requisition: FC = () => {
  return (
    <Box flexDirection={{ sm: 'column' }} css={{ width: '100%', height: '100%' }} flexGrow={{ sm: '1' }}>
      <ErrorBoundary>
        <Box flexDirection={{ sm: 'column' }}>
          <PageHeader>
            <HeaderLogo />
          </PageHeader>
        </Box>
        <Routes>
          <Route index element={<ActiveRequisition />} />
          <Route path="history/*" element={<RequisitionHistory />} />
        </Routes>
        <Outlet></Outlet>
        <ToastContent position={ToastPosition.MIDDLE} animateFrom={ToastAnimateFrom.BOTTOM} />
      </ErrorBoundary>
    </Box>
  );
};

export default Requisition;
